import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    UpgradeHelper, AdminToolHelper, IJESettingsSidebar
} from '../../helpers';
import { NO_VALUE_OPERATORS } from '../../constants';
import { Button, Pivot, PivotItem, PivotLinkSize, IDropdownOption } from 'office-ui-fabric-react';
import store from '../../store/store';
import { CheckboxList } from '../';
import { UpgradeScreen } from '../admintool/screens/upgradescreen';
import { ImportScreen } from '../admintool/screens/importscreen';
import { JourneyExportScreen } from '../admintool/screens/journeyexportscreen';
import { RollbackScreen } from '../admintool/screens/rollbackscreen';
import ErrorDisplayContainer from '../../containers/error-display';
import { JESettingsScreen } from './screens/jesettingsscreen';
import types from '../../store/types';

interface IProps {
    searchState: any;
    adminToolState: any;
    sidebarState: any;
}
export class AdminTool extends React.Component<IProps, any> {
    componentDidMount() {
        if (!this.props.adminToolState.adminToolVersion) {
            AdminToolHelper.getAdminToolVersion();
        }
    }
    constructor(props: any) {
        super(props);

    }

    onPivotLinkClicked(item: PivotItem) {
        AdminToolHelper.SetTab(item.props.linkText);
    }

    toggleSidebar() {
        let sidebar: IJESettingsSidebar = { isOpen: true, type: "new", jesetting: null, isSuccess: false, formValidationError: [], error: null };
        store.dispatch({
            type: types.SET_JESETTINGS_SIDEBAR,
            sidebar: sidebar,
        });

    }
    render() {
        let className = "admintool" + ((this.props.adminToolState.isUpgradingScreen) ? " admintool-isprocessingscreen" : "");
        return (<div className={className}>
            <h1 className="upgradetitle"><span className="ms-font-su">Welcome to the <strong>Webcurl Self Serve Admin Tool</strong></span></h1>
            <ErrorDisplayContainer />
            <Pivot linkSize={PivotLinkSize.large} onLinkClick={this.onPivotLinkClicked} >
                <PivotItem disabled={this.props.adminToolState.isProccessing} key="pivot_upgrade" linkText='Upgrade'>
                    <UpgradeScreen adminToolState={this.props.adminToolState} searchState={this.props.searchState} />
                </PivotItem>
                <PivotItem disabled={this.props.adminToolState.isProccessing} key="pivot_export" linkText='Export'>
                    <JourneyExportScreen adminToolState={this.props.adminToolState} searchState={this.props.searchState} />
                </PivotItem>
                <PivotItem disabled={this.props.adminToolState.isProccessing} key="pivot_import" linkText='Import'>
                    <ImportScreen adminToolState={this.props.adminToolState} searchState={this.props.searchState} />
                </PivotItem>
                <PivotItem disabled={this.props.adminToolState.isProccessing} key="pivot_import" linkText='Rollback'>
                    <RollbackScreen adminToolState={this.props.adminToolState} searchState={this.props.searchState} />
                </PivotItem>
                <PivotItem disabled={this.props.adminToolState.isProccessing} key="pivot_jesettings" linkText='JE Settings'>
                    {/* <RollbackScreen adminToolState={this.props.adminToolState} searchState={this.props.searchState} /> */}
                    <JESettingsScreen toggleSidebar={this.toggleSidebar} adminToolState={this.props.adminToolState} searchState={this.props.searchState} />
                </PivotItem>

            </Pivot>
        </div>
        );
    }
}


// WEBPACK FOOTER //
// ./source/ts/components/admintool/index.tsx